import "./AddMoney.css";
import React, { useState } from "react";
import ellipses from "../../Assets/Images/circle-grp.png";
import wallet from "../../Assets/Images/wallet.png";
import { useNavigate } from "react-router-dom";
import storage from "@utils/storage";
import axios from "axios";
import { toast } from "react-toastify";
import envConfig from "../../environment";
import { useGetWalletQuery } from "../../API/Transaction";
import { defaultParams } from "@utils/global.constants";

const WithdrawMoney = () => {
  const navigate = useNavigate();
  const user = storage.getUser();
  const userId = user?.user?.userId;
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [params] = useState({ ...defaultParams });
  const [onboardingUrl, setOnboardingUrl] = useState<string | null>(null);
  const { data: walletData } = useGetWalletQuery(userId, params);
  const walletAmount: number = walletData?.totalAmount || 0;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      return toast.error("Please enter a valid amount.");
    }

    setLoading(true);

    try {
      const token = storage.getToken();

      const response = await axios.post(
        `${envConfig.apiUrl.replace(/\/$/, "")}/stripe/withdraw-money`,
        { amount, userId, redirectPath: "/app/withdraw-money" },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const {
        success,
        message,
        needsOnboarding,
        onboardingUrl,
        walletAvailable,
        stripeAvailable,
        requested,
        estimatedAvailability,
      } = response.data;

      if (success) {
        toast.success(message || "Payout successful!");
        navigate("/app/wallet");
        return;
      }

      // 🧾 CASE 1: Stripe onboarding needed
      if (needsOnboarding && onboardingUrl) {
        setOnboardingUrl(onboardingUrl); // Show onboarding button (don't auto-redirect)
        toast.info("Your Stripe account needs onboarding to receive payouts.");
        return;
      }

      // 💰 CASE 2: Insufficient wallet or Stripe balance
      const shortMsgParts: string[] = [];

      if (walletAvailable !== undefined && requested !== undefined) {
        shortMsgParts.push(
          `Wallet balance is £${walletAvailable.toFixed(2)} but requested £${requested.toFixed(2)}`
        );
      }

      if (stripeAvailable !== undefined && requested !== undefined) {
        shortMsgParts.push(
          `Stripe available balance is £${stripeAvailable.toFixed(2)} but requested £${requested.toFixed(2)}`
        );
      }

      if (shortMsgParts.length > 0) {
        toast.error(shortMsgParts.join(". "));
        return;
      }

      // CASE 3: Generic known error
      if (message) {
        toast.error(message);
        return;
      }

      // CASE 4: Unknown edge case
      toast.error("Withdrawal failed due to an unknown issue.");

    } catch (err: any) {
      const errorData = err?.response?.data;

      // 🧾 Onboarding required from error
      if (errorData?.needsOnboarding && errorData?.onboardingUrl) {
        setOnboardingUrl(errorData.onboardingUrl);
        toast.info("Your Stripe account needs onboarding to proceed with payouts.");
        return; // Don't navigate
      }

      // Fallback error
      toast.error(
        errorData?.message || err.message || "Withdrawal failed"
      );
    } finally {
      setLoading(false);
    }
  };





  return (
    <div className="content dashboard">
      <div className="content-wrapper add-money-section">
        <div className="title-search-block d-flex align-items-center justify-content-between">
          <div className="input-btn-fields d-flex align-items-center">
            <button className="back-btn mb-4" onClick={() => navigate(-1)}>Back</button>
          </div>
        </div>

        <h5 className="heading withdraw-moeny-title">Withdraw Money from Wallet</h5>

          <div className="row withdraw-money-row">
            {/* Wallet Card */}
            <div className="withdraw-money-wrapper d-flex align-items-center justify-content-center">
              <div className="lendriva-box h-100 position-relative overflow-hidden">
                <div className="inner-box-content h-100 d-flex justify-content-between align-items-end">
                  <div className="content-lower">
                    <p className="">Wallet Holder</p>
                    <h5 className="m-0">
                      {user?.user?.firstName ?? "Andrew"} {user?.user?.lastName ?? "Lender"}
                    </h5>
                  </div>
                  <div className="wallet-balance">
                    <h2 className="">£{walletAmount.toFixed(2)}</h2>
                    <p className="m-0">Wallet Balance</p>
                  </div>
                </div>
                <div className="content-upper">
                  <div className="wallet wallet-db position-absolute">
                    <img src={wallet} alt="" className="img-fluid" />
                  </div>
                </div>
                {/* <div className="grouped-ellipse wallet-grpd-ellipse position-absolute">
                  <img src={ellipses} alt="" className="img-fluid" />
                </div> */}
              </div>
            </div>

            {/* Withdraw Form */}
            <div className="withdraw-fund-wrapper">
              <div className="form-card withdraw-funds h-100">
                <div className="form-title mb-4">
                  {/* <span className="me-2">
                    <svg width="24" height="24" fill="none">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 5C0 4.2 0.3 3.4 0.9 2.9C1.4 2.3 2.2 2 3 2H21C21.8 2 22.6 2.3 23.1 2.9C23.7 3.4 24 4.2 24 5H0ZM0 8V17C0 17.8 0.3 18.6 0.9 19.1C1.4 19.7 2.2 20 3 20H21C21.8 20 22.6 19.7 23.1 19.1C23.7 18.6 24 17.8 24 17V8H0ZM4.5 15.5C4.5 15.1 4.7 14.7 4.9 14.4C5.2 14.2 5.6 14 6 14H7.5C7.9 14 8.3 14.2 8.6 14.4C8.8 14.7 9 15.1 9 15.5C9 15.9 8.8 16.3 8.6 16.6C8.3 16.8 7.9 17 7.5 17H6C5.6 17 5.2 16.8 4.9 16.6C4.7 16.3 4.5 15.9 4.5 15.5Z"
                        fill="#00B8D9"
                      />
                    </svg>
                  </span> */}
                  Withdraw Funds
                </div>
                {onboardingUrl && (
                  <div className="alert-box alert-warning mt-4 text-center p-4 m-4">
                    <p className="mb-6">
                      Your Stripe account isn’t ready to receive payouts. Please complete your onboarding.
                    </p>
                    <div style={{ textAlign: "center", marginTop: "28px" }}>
                      <a style={{ cursor: "pointer" }}
                        onClick={() => {
                          window.location.href = onboardingUrl; // 👈 open in same tab
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        className=" w-100 fw-normal text-decoration-none font-style-italic mt-6"
                      >
                        Complete Stripe Onboarding
                      </a>

                    </div>

                  </div>
                )}

                <form onSubmit={handleSubmit} className="payment-form onboarding-form">
                  <div className="mb-3">
                    {/* <label className="form-label">Amount to Withdraw</label> */}
                    <input
                      type="text"
                      className="form-control"
                      placeholder="£12000"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value.replace(/[^0-9.]/g, ""))}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="button-withdraw-money w-100 fw-normal"
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Withdraw Money"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    
  );
};

export default WithdrawMoney;
